import { ViewModel,View, ObservableArray } from "binder"
import { FileSelectorViewModel } from "uicomponents";
import { AttachmentDownloader } from "../attachmentFileDownloader";
import  { AttachmentListSelectorView } from "./attachmentListSelector-view"

export class AttachmentListSelectorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    
        this.attachments = ObservableArray.create<attachmentViewModel>();
        this.isReadonly = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new AttachmentListSelectorView();
    }
    public getTypeId(): string {
        return "VM-D4A004AE-65D5-4C7E-8CD9-233C55A40C4D"
    }
    public set isReadonly(v: boolean) { 
        this._isReadonly = v; 
        this.updateReadonly();
    } public get isReadonly(): boolean { return this._isReadonly;} private _isReadonly: boolean;
    public set attachments(v: ObservableArray<attachmentViewModel>) { this._attachments = v; } public get attachments(): ObservableArray<attachmentViewModel> { return this._attachments;} private _attachments: ObservableArray<attachmentViewModel>;
    
    updateReadonly(){
        this.attachments.forEach(q=>q.isReadOnly = this.isReadonly);
    }
    removeAttachment(attachment: attachmentViewModel) {
        this.attachments.remove(attachment);
    }
    addNewAttachment(){
        let attachment = new attachmentViewModel(this);
        this.attachments.push(attachment);
        attachment.choose();
        this.updateReadonly();
    }

    getAttachments():{id:string,name:string,content:string}[] {
        return this.attachments.filter(x=>x.fileSelector.isFileChoosed()).map(x=>{return {
            id:x.fileSelector.fileid,
            name:x.fileSelector.filename,
            content:x.fileSelector.filecontent
        }});
    }
    
}

export class attachmentViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:AttachmentListSelectorViewModel) {
        super(parent);
        this._typedParent = parent;
        this.fileSelector = new FileSelectorViewModel(this, 500);
        this.fileSelector.downloader = new AttachmentDownloader();
    }

    private _typedParent : AttachmentListSelectorViewModel;

    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isReadOnly(v: boolean) { 
        this._isReadOnly = v; 
        this.fileSelector.isreadonly = this.isReadOnly;
    } public get isReadOnly(): boolean { return this._isReadOnly;} private _isReadOnly: boolean;
    
    async setInfo(id:string,name:string){
        this.fileSelector.filename = name;
        this.fileSelector.fileid = id;
    }
    async choose() {
        this.fileSelector.chooseFile();
    }
    
    remove(){
        this._typedParent.removeAttachment(this);
    }
}